import { render, staticRenderFns } from "./tagInput.vue?vue&type=template&id=317b421e&scoped=true"
import script from "./tagInput.vue?vue&type=script&lang=js"
export * from "./tagInput.vue?vue&type=script&lang=js"
import style0 from "./tagInput.vue?vue&type=style&index=0&id=317b421e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317b421e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317b421e')) {
      api.createRecord('317b421e', component.options)
    } else {
      api.reload('317b421e', component.options)
    }
    module.hot.accept("./tagInput.vue?vue&type=template&id=317b421e&scoped=true", function () {
      api.rerender('317b421e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/advancecomponets/children/tagInput.vue"
export default component.exports